import { Component } from "preact";
import { shallowDiffer } from "../foundation/utils/diff";

// eslint-disable-next-line @typescript-eslint/ban-types
abstract class PureComponent<P = {}, S = {}> extends Component<P, S> {
    static isPureReactComponent: boolean;

    override shouldComponentUpdate(props: P, state: S) {
        return shallowDiffer(this.props, props) || shallowDiffer(this.state, state);
    }
}

PureComponent.isPureReactComponent = true;

export default PureComponent;
